var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell",class:{active: _vm.gameActive},on:{"click":_vm.markCell}},[(_vm.state !== 'empty')?_c('span',{staticClass:"mark"},[_vm._v(_vm._s(_vm.state))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }